document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-office-search-form]").forEach((form) => {
    const input = form.querySelector("[data-office-search-input]");
    const scope = form.querySelector("[data-office-search-scope]");
    const submit = form.querySelector("[data-office-search-submit]");

    if (!input || !scope || !submit) return;

    const syncSearchMode = () => {
      const waybillMode = scope.value === "legacy_waybill";

      form.action = waybillMode ? form.dataset.waybillAction : form.dataset.destinationAction;
      input.name = waybillMode ? "search" : "code";
      input.placeholder = waybillMode ? input.dataset.waybillPlaceholder : input.dataset.destinationPlaceholder;
      input.setAttribute("aria-label", input.placeholder);
      submit.name = waybillMode ? "submit_waybill_code" : submit.dataset.destinationSubmitName;
    };

    scope.addEventListener("change", syncSearchMode);
    syncSearchMode();
  });
});
